import * as angular from 'angular';
import 'angular-smart-table';
import {SerfWebCore} from '../core/core.module';

import {TestpageViewComponentConfig} from './component/testpageView/testpageView';
import {testpageRun} from './testpage.route';


export const SerfWebTestpage = angular.module('serfWeb.testpage', [SerfWebCore.name, 'smart-table', 'ui.bootstrap'])
    .component('dvTestpageView', new TestpageViewComponentConfig())
    .run(testpageRun);

export default SerfWebTestpage;



// WEBPACK FOOTER //
// ./src/app/testpage/testpage.module.ts